import { SelectField, type SelectFieldProps } from '@ff-it/form';
import type { ReactElement } from 'react';
import { taskStatusOptions, type TaskStatus } from './types';
import { TaskStatusTag } from './TaskStatusTag';
import type { Option } from 'options';

type TaksStatusFieldProps = Omit<
  SelectFieldProps<Option<TaskStatus>, any, any>,
  'options' | 'loadOptions' | 'defaultOptions' | 'simple'
>;
const formatOptionLabel = ({ value }: Option<TaskStatus>) => <TaskStatusTag state={value} appearance="naked" />;

export function TaksStatusField(props: TaksStatusFieldProps): ReactElement {
  return <SelectField options={taskStatusOptions} simple formatOptionLabel={formatOptionLabel} {...props} />;
}
